var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8466 29.668H12.1533C5.60664 29.668 2.80664 26.868 2.80664 20.3213V20.148C2.80664 14.228 5.13997 11.3746 10.3666 10.8813C10.9 10.8413 11.4066 11.2413 11.46 11.788C11.5133 12.3346 11.1133 12.828 10.5533 12.8813C6.36664 13.268 4.80664 15.2413 4.80664 20.1613V20.3346C4.80664 25.7613 6.72664 27.6813 12.1533 27.6813H20.8466C26.2733 27.6813 28.1933 25.7613 28.1933 20.3346V20.1613C28.1933 15.2146 26.6066 13.2413 22.34 12.8813C21.7933 12.828 21.38 12.348 21.4333 11.8013C21.4866 11.2546 21.9533 10.8413 22.5133 10.8946C27.82 11.348 30.1933 14.2146 30.1933 20.1746V20.348C30.1933 26.868 27.3933 29.668 20.8466 29.668Z",
    fill: "#8F98A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 20.8413C15.9533 20.8413 15.5 20.388 15.5 19.8413V2.66797C15.5 2.1213 15.9533 1.66797 16.5 1.66797C17.0466 1.66797 17.5 2.1213 17.5 2.66797V19.8413C17.5 20.4013 17.0466 20.8413 16.5 20.8413Z",
    fill: "#8F98A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 22.3346C16.2466 22.3346 15.9933 22.2413 15.7933 22.0413L11.3266 17.5746C10.94 17.188 10.94 16.548 11.3266 16.1613C11.7133 15.7746 12.3533 15.7746 12.74 16.1613L16.5 19.9213L20.26 16.1613C20.6466 15.7746 21.2866 15.7746 21.6733 16.1613C22.06 16.548 22.06 17.188 21.6733 17.5746L17.2066 22.0413C17.0066 22.2413 16.7533 22.3346 16.5 22.3346Z",
    fill: "#8F98A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportFile);
export default __webpack_public_path__ + "static/media/import-file.040e58702bb2ce7cb70f8026d73082d9.svg";
export { ForwardRef as ReactComponent };